import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search } from "lucide-react";
import { Button } from "@/components/ui/button";
import { CitySelect } from "@/components/CitySelect";

export const SearchBar = ({ cities, initialQ = "", initialCity = "", testPrefix = "hero" }) => {
  const navigate = useNavigate();
  const [q, setQ] = useState(initialQ);
  const [city, setCity] = useState(initialCity);
  const submit = (e) => {
    e.preventDefault();
    if (!q.trim()) return;
    navigate(`/cari?q=${encodeURIComponent(q.trim())}${city ? `&kota=${city}` : ""}`);
  };
  return (
    <form onSubmit={submit} data-testid={`${testPrefix}-search-form`}
      className="flex flex-col gap-2 rounded-2xl border border-stone-200 bg-white p-2 shadow-[0_12px_40px_-16px_rgba(28,25,23,0.18)] sm:flex-row sm:items-center">
      <div className="flex flex-1 items-center gap-2 px-3">
        <Search className="h-5 w-5 shrink-0 text-stone-400" />
        <input
          value={q}
          onChange={(e) => setQ(e.target.value)}
          placeholder="Cari jasa apa?"
          data-testid={`${testPrefix}-search-input`}
          className="h-11 w-full bg-transparent text-[15px] text-stone-900 placeholder:text-stone-400 focus:outline-none"
        />
      </div>
      <div className="sm:w-48">
        <CitySelect cities={cities} value={city} onChange={setCity} testId={`${testPrefix}-city-select`} className="border-0 bg-stone-50 sm:bg-stone-50" />
      </div>
      <Button type="submit" data-testid={`${testPrefix}-search-button`} className="h-11 rounded-xl bg-teal-700 px-6 font-semibold hover:bg-teal-800 active:scale-[0.98]">
        Cari
      </Button>
    </form>
  );
};
